<template>
  <ModalCancelService />
  <div class="row">
    <div class="col-xxl-8">
      <div
        class="card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing radius-7"
      >
        <div class="card-body">
          <ul
            class="nav nav-tabs bg-white border-0 rounded-0 radius-7"
            id="myTab"
            role="tablist"
          >

            <li class="nav-item" role="presentation">
              <button
                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 active radius-7"
                id="payment-method-tab"
                data-bs-toggle="tab"
                data-bs-target="#payment-method-tab-pane"
                type="button"
                role="tab"
                aria-controls="payment-method-tab-pane"
                aria-selected="true"
              >
                <i class="flaticon-atm"></i>
                Modo de pagamento
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button
                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 radius-7"
                id="place-order-tab"
                data-bs-toggle="tab"
                data-bs-target="#place-order-tab-pane"
                type="button"
                role="tab"
                aria-controls="place-order-tab-pane"
                aria-selected="false"
              >
                <i class="flaticon-calendar"></i>
                Histórico de pagamentos
              </button>
            </li>

          </ul>

          <div
            class="tab-content p-15 p-sm-20 p-md-25 p-lg-30"
            id="myTabContent"
          >
            <div
              class="tab-pane fade show active"
              id="payment-method-tab-pane"
              role="tabpanel"
              tabindex="0"
            >
              <div id="paymentAccordion">
                <div class="accordion-item rounded-0 radius-7">

                    <div v-if="getSummary.enable_payment" >
                      <h4 class="mb-20 font-14">Cartão de crédito</h4>
                      <div class="mb-30 style-stripe card-element" id="card-element" ref="cardElement"></div>
                      <div v-if="!getLoadingPaymentMode && getPaymentModeDefault.length == 0">
                        <div>
                          <form @submit.prevent="submitForm" id="payment-form">
                            <button ref="buttonConfirmPaymentStripe" class="default-btn transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success" type="submit">
                              Confirmar pagamento
                              <!-- <i class="flaticon-right-arrow position-relative ms-5 top-2"></i> -->
                              <i class="flaticon-chevron position-relative ms-5 top-2"></i>
                            </button>
                          </form>
    
                          <div v-if="getErrorPayment != ''" class="mt-40 alert alert-danger d-flex align-items-center fs-md-15 fs-lg-16" role="alert">
                            <i class="flaticon-spam lh-1 fs-20 position-relative top-1 me-8"></i>
                            {{ getErrorPayment }}
                          </div>
    
                          <div v-if="getSuccessPayment != ''" class="mt-40 alert alert-success d-flex align-items-center fs-md-15 fs-lg-16" role="alert">
                            <i class="flaticon-party lh-1 fs-20 position-relative top-1 me-8"></i>
                            {{ getSuccessPayment }}
                          </div>
    
                        </div>
                      </div>
                      <div v-if="!getLoadingPaymentMode && getPaymentModeDefault.length > 0">
                        <div class="d-flex flex-column w-100 font-12 mb-0" v-for="(value, key) in getPaymentModeDefault" :key="key">
                          <div>
                            <strong>Modo de pagamento:</strong> {{ value.payment_mode }} <br>
                            <strong>Identificação:</strong> {{ value.information }} <br>
                            <strong>Status do serviço:</strong> {{ value.active }} <br>
                            <strong>Frequência de cobrança:</strong> Uma vez por mês <br>
                          </div>
    
                          <button 
                            v-if="value.active == 'Ativo'"
                            class="width-50 mt-20 default-btn transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-danger" 
                            data-bs-toggle="modal" data-bs-target="#CancelServiceCenteredModal"
                            type="button"
                          >
                            Cancelar serviço
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-else class="d-flex area-payment-not-value">
                      <i class="flaticon flaticon-price-tag-2"></i>
                      <div class="ml-10">O valor mínimo de pagamento é de 0,50 centavos</div>
                    </div>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="place-order-tab-pane"
              role="tabpanel"
              tabindex="0"
            >
              <div id="paymentAccordion">
                <div class="accordion-item rounded-0 radius-7">
                  <PaymentHistory />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-xxl-4">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-summary-box letter-spacing radius-7 container-value-price"
      >
        <div class="card-head bg-white d-flex align-items-center card-checkout-title">
          
          <i class="flaticon-form font-22 color-font-general"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15 font-16 color-font-general">
            Valores
          </h5>

        </div>
        <div class="card-body content-checkout-style">
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <tbody>
                <tr>
                  <th
                    class="shadow-none fw-medium text-black product-title ps-0"
                  >
                    <div class="d-flex align-items-center text-decoration-none text-black fs-md-15 fs-lg-16">
                      <img
                        src="../../assets/images/payment/image-checkout.png"
                        class="me-15 radius-7"
                        width="44"
                        alt="product"
                      />
                      <span
                        >Armazenamento<br>
                        <span class="fs-12 fw-medium text-muted">Sistema já incluso</span>
                      </span>
                    </div>
                  </th>
                  <td
                    class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0"
                  >
                    R$ {{ getSummary.contracted_value }}/GB
                  </td>
                </tr>

                <tr>
                  <th
                    class="shadow-none fw-medium text-black product-title ps-0"
                  >
                    <div class="d-flex align-items-center text-decoration-none text-black fs-md-15 fs-lg-16">
                      <img
                        src="../../assets/images/payment/transcricao.png"
                        class="me-15 radius-7"
                        width="44"
                        alt="product"
                      />
                      <span
                        >Transcrição<br>
                      </span>
                    </div>
                  </th>
                  <td
                    class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0"
                  >
                    R$ {{ getSummary.transcription_value }}/Min
                  </td>
                </tr>

                <tr>
                  <th
                    class="shadow-none fw-medium text-black product-title ps-0"
                  >
                    <div class="d-flex align-items-center text-decoration-none text-black fs-md-15 fs-lg-16">
                      <img
                        src="../../assets/images/payment/analyse-sentiment.png"
                        class="me-15 radius-7"
                        width="44"
                        alt="product"
                      />
                      <span
                        >Análise de sentimento<br>
                      </span>
                    </div>
                  </th>
                  <td
                    class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0"
                  >
                    R$ {{ getSummary.analyse_sentiment_value }}/Min
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>

          <h5 class="mb-0 fw-bold text-black text-center mt-25 font-16 color-font-general">
            Consumo atual:
          </h5>

          <ul class="order-summary-list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between checkout-summary-price pt-2">
              <span class="d-block text-paragraph fw-medium">
                Qtd. Gravações
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ getSummary.quantity_items }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between checkout-summary-price pt-0">
              <span class="d-block text-paragraph fw-medium">
                Espaço utilizado
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ getSummary.total_size }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between checkout-summary-price border-dashed pt-0">
              <span class="d-block text-paragraph fw-medium">
                Valor armazenamento
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ getSummary.total_value }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between checkout-summary-price">
              <span class="d-block text-paragraph fw-medium">
                Minutagem transcrição
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ convertTime(getSummary.minutes_transcription) }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between checkout-summary-price border-dashed pt-0">
              <span class="d-block text-paragraph fw-medium">
                Valor transcrição
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ getSummary.total_value_minutes_transcription }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between checkout-summary-price">
              <span class="d-block text-paragraph fw-medium">
                Minutagem análise de sentimento
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ convertTime(getSummary.minutes_analyse_sentiment) }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between checkout-summary-price border-dashed pt-0">
              <span class="d-block text-paragraph fw-medium">
                Valor Análise de sentimento
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                {{ getSummary.total_value_minutes_analyse_sentiment }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between checkout-summary-price">
              <span class="d-block text-paragraph ">
                <strong>Valor total</strong>
              </span>
              <span class="d-block text-black fs-md-15 fs-lg-16 ">
                <strong>{{ getSummary.total_price }}</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { mapGetters, mapActions } from 'vuex';
import PaymentHistory from "./PaymentHistory.vue";
import ModalCancelService from "./ModalCancelService.vue";
import moment from 'moment';

export default {
  name: "CheckoutContent",
  components: {
    PaymentHistory,
    ModalCancelService
  },
  data() {
    return {
      stripe: null,
      cardElement: null,
      form: {
        name: '',
        email: '',
        company_id: ''
      }
    };
  },
  async mounted() {
    this.setPaymentHistory();
    this.setDaysExportFiles();

    this.setPaymentModeDefault().then(async () => {
      if(this.getPaymentModeDefault.length > 0){
        this.$refs.cardElement.style.display = "none";
        return;
      }
      this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
      const elements = this.stripe.elements();

      var card = elements.create("card", {
        hidePostalCode: true,
        style: {
          base: {
            color: '#10223b',
            fontFamily: '"Red Hat Display", sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '15px',
            '::placeholder': {
              color: '#96a4b6'
            },
          },
          invalid: {
            color: '#c33f52',
            iconColor: '#c33f52'
          }
        }
      });

      card.mount("#card-element");
      this.cardElement = card;
      this.cardElement.mount('#card-element');
    });

    this.setSummary();
  },
  computed:{
    ...mapGetters([
      "getSummary",
      "getErrorPayment",
      "getSuccessPayment",
      "getPaymentModeDefault",
      "getLoadingPaymentMode"
    ])
  },
  methods: {
    ...mapActions([
      "setProcessSubscriptionPayment",
      "setSummary",
      "setResetErrorPayment",
      "setPaymentModeDefault",
      "setPaymentHistory",
      "setDaysExportFiles"
    ]),
    convertTime(time) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    },
    async submitForm() {

      const buttonConfirmPaymentStripe = this.$refs.buttonConfirmPaymentStripe;
      buttonConfirmPaymentStripe.disabled = true;
      buttonConfirmPaymentStripe.innerHTML = "Processando pagamento..."

      try{

        this.setResetErrorPayment();
        const { token, errorCardElement } = await this.stripe.createToken(this.cardElement);
  
        let cardNumber = "";
        if(token && token.card && token.card.last4){
          cardNumber = token.card.last4
        }
        
        const { paymentMethod, errorCreatpayment } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: 'Customer Nameee',
          },
        });
  
        if (errorCardElement || errorCreatpayment) {
          window.location.reload();
        } else {
  
          const data = {
            cardCreated: paymentMethod.id,
            cardNumber: cardNumber
          };
  
          const buttonConfirmPaymentStripe = this.$refs.buttonConfirmPaymentStripe;
          buttonConfirmPaymentStripe.disabled = true;
          buttonConfirmPaymentStripe.innerHTML = "Processando pagamento..."
          
          this.setProcessSubscriptionPayment(data).then(() => {
            buttonConfirmPaymentStripe.disabled = false;
            buttonConfirmPaymentStripe.innerHTML = "Confirmar pagamento"
          });
        }

      } catch(error){
        buttonConfirmPaymentStripe.disabled = false;
        buttonConfirmPaymentStripe.innerHTML = "Confirmar pagamento"
      }
      
    }
  }
};
</script>
<style scoped>
.border-dashed{
  border-bottom: 1px dashed #ccc !important;
}
/* Estilo para o formulário */
#payment-form {
  max-width: 400px;
  margin: auto;
}

#payment-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
}

#payment-form input[type="text"],
#payment-form input[type="email"],
#payment-form input[type="radio"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Estilo para o botão de envio */
#payment-form button {
  width: 100%;
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#payment-form button:hover {
  background-color: #45a049;
}

/* Estilo para o elemento do cartão */
.stripe-card-element {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 16px;
}

/* Estilos para estados do elemento do cartão */
.stripe-card-element input {
  font-size: 16px;
}

.stripe-card-element .StripeElement--invalid {
  border-color: #fa755a;
}

.stripe-card-element .StripeElement--focus {
  border-color: #4CAF50;
}

/* Estilo específico para o campo de número do cartão */
.InputElement {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 16px;
  background-color: #45a049 !;
}

.InputElement:focus {
  border-color: #4CAF50;
  outline: none;
}

.InputElement--invalid {
  border-color: #fa755a;
}

.InputElement--focus {
  border-color: #4CAF50;
}

.InputElement{
  background-color: #45a049;
}



.card-element {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
}

#card-errors {
  color: #fa755a;
}

</style>
